export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-sketches-56be6c6f85128f18f92ad80924e35985.png";